<div class="filters-sec flex-header">
  <div class="row">
    <div class="col-xs-2">
      <input class="form-control" [(ngModel)]="filter['name']" (keyup.enter)="search()" placeholder="Patient">
    </div>
    <div class="col-xs-2">
      <select [(ngModel)]="filter['status']" class="form-control">
        <option value=undefined selected>Status</option>
        <option value='all'>All</option>
        <option value='unresolved'>Unresolved</option>
        <option value='resolved'>Resolved</option>
      </select>
    </div>

    <div class="col-xs-2">
      <select [(ngModel)]="filter['severity']" class="form-control">
        <option value='all' selected>Severity</option>
        <option value='critical'>Critical</option>
        <option value='high'>High</option>
        <option value='low'>Low</option>
        <option value='normal'>Normal</option>
      </select>
    </div>


    <div class="col-xs-2">
      <select class="form-control" [(ngModel)]="filter['no_of_days']" name="no_of_days">
        <option value="last_seven_days">Last 7 Days</option>
        <option value="last_fourteen_days">Last 14 days</option>
        <option value="last_thirty_days">Last 30 days</option>
        <option value="current_month">Current Month</option>
        <option value="custom">Custom</option>
      </select>
    </div>

    <ng-container *ngIf="filter['no_of_days'] == 'custom'">
      <div class="col-xs-2">
        <input [(ngModel)]="dateRangeValue" type="text"
               placeholder="Datepicker"
               class="form-control" [outsideClick]="true"
               (bsValueChange)="setDateRange($event)"
               [bsConfig]="{ customTodayClass: 'today-date-select', showWeekNumbers:false }"
               bsDaterangepicker/>
      </div>
    </ng-container>

    <div class="col-xs-2">
      <button type="button" class="btn btn-tertiary btn-outline btm-min" (click)="search()"><i class="fa fa-filter"></i> Filter</button>
    </div>
  </div>
</div>
<div class="flex-body scroll-browser">
  <table class="table table-hover m0">
    <thead>
    <tr>
      <th>Alert</th>
      <th>Patient</th>
      <th>DOB</th>
      <th>Severity</th>
      <th>Type</th>
      <th>Status</th>
      <th>Alert Age</th>
      <th>Date</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let alert of alerts">
      <td><span placement="bottom" ngbTooltip="{{alert?.alert_template?.guideline}}">{{alert?.alert_template?.description}}</span></td>
      <td><a (click)="openEnrolledPatient(alert?.patient, alert?.programme)">{{alert?.patient?.name}}</a></td>
      <td>{{alert?.patient?.dob | date: 'shortDate'}}</td>
      <td class="text-capitalize">{{alert?.alert_template?.severity}}</td>
      <td>{{userService.removeUnderScore(alert?.alert_template?.alert_type)}}</td>
      <td class="text-center">
        <label *ngIf="alert?.status"
               class="label m0"
               [class.label-danger]="alert.status === 'Unresolved'"
               [class.label-success]="alert.status === 'Resolved'">
          {{alert.status}}
        </label>
      </td>
      <td>{{alert?.alert_age}}</td>
      <td>{{alert?.created_at | date : 'medium'}}</td>
    </tr>
    </tbody>
  </table>
  <app-no-result-found *ngIf="alerts && alerts.length == 0"></app-no-result-found>
</div>
<div class="flex-footer text-center" *ngIf="alerts && totalItems > 10">
  <pagination class="m0" [totalItems]="totalItems" [maxSize]="3" [itemsPerPage]="10" (pageChanged)="pageChanged($event)"></pagination>
</div>


<div class="modal fade" bsModal #selectTypeFromAlertModal="bs-modal" [config]="{backdrop: false}" tabindex="-1">
  <div class="modal-dialog modal-md" style="height:200px;">
    <div class="modal-content">
      <div class="modal-header">
        <button class="close" type="button" (click)="selectTypeFromAlertModal.hide()"><i class="fa fa-times fs16"></i></button>
        <h4 class="modal-title text-center">Select a Program Type</h4>
      </div>
      <div class="modal-body">
        <div class="row form-group mb0">
          <div class="modal-col col-md-12  col-xs-12" style="justify-content: center; align-items: center; display: flex;">
            <ng-container *ngFor="let type of enrolled_in">
              <label class="fw-500 mr-lg text-capitalize">
                <input type="radio" class="ml" name="{{type}}" [value]="type" [(ngModel)]="selectProgramType"  />
                {{type}}
              </label>
            </ng-container>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-secondary" (click)="selectProgramTypeToOpen();selectTypeFromAlertModal.hide()" [disabled]="!selectProgramType">Continue</button>
        <button type="submit" class="btn btn-tertiary btn-outline" (click)="closeSelectProgramModel()">Cancel</button>
      </div>
    </div>
  </div>
</div>
